export enum WorkAndRestTableEnum {
  Matrix = 'Matrix',
  WorkApproval = 'WorkApproval',
  SignOff = 'SignOff',
  WorkAndRest = 'WorkAndRest',
  WorkPlanValidation = 'WorkPlanValidation',
}
